import { render, staticRenderFns } from "./ItemGol2p.vue?vue&type=template&id=37390e42&scoped=true&"
import script from "./ItemGol2p.vue?vue&type=script&lang=js&"
export * from "./ItemGol2p.vue?vue&type=script&lang=js&"
import style0 from "./ItemGol2p.vue?vue&type=style&index=0&id=37390e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37390e42",
  null
  
)

export default component.exports